import apiClient from 'utils/api';

export const checkHealth = async (): Promise<any> => {
	const { data } = await apiClient.get('/health');
	return data;
};
